"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var _UISlideoutDrawer = _interopRequireDefault(require("UIComponents/slideout/UISlideoutDrawer"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var propTypes = {
  ControlsAreaComponent: _react.PropTypes.func,
  cancelLabel: _react.PropTypes.node.isRequired,
  children: _react.PropTypes.array,
  controlSize: _react.PropTypes.oneOf(['default', 'small', 'extra-small']),
  controlsAreaComponentProps: _react.PropTypes.object,
  controlsButtonsClassName: _react.PropTypes.string,
  controlsClassName: _react.PropTypes.string,
  insetUseClassName: _react.PropTypes.string,
  onCancel: _react.PropTypes.func.isRequired,
  onSave: _react.PropTypes.func.isRequired,
  onSecondarySave: _react.PropTypes.func,
  open: _react.PropTypes.bool,
  overrideDrawStyle: _react.PropTypes.bool,
  saveDisabled: _react.PropTypes.bool,
  saveLabel: _react.PropTypes.node.isRequired,
  saveOnEnter: _react.PropTypes.bool,
  saveTooltip: _react.PropTypes.shape({
    headingText: _react.PropTypes.string,
    onClose: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.string,
    title: _react.PropTypes.string,
    use: _react.PropTypes.string,
    disabled: _react.PropTypes.bool
  }),
  secondarySaveButtonContent: _react.PropTypes.func,
  showCancel: _react.PropTypes.bool,
  showControlsBorder: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(['inset', 'flush']),
  useTertiaryButtons: _react.PropTypes.bool,
  wrapperClassName: _react.PropTypes.string,
  useStickyControls: _react.PropTypes.bool
};

var GENERIC_SAVE_LABEL = _react.default.createElement(_FormattedMessage.default, {
  message: "customerDataRte.actions.save"
});

var GENERIC_CANCEL_LABEL = _react.default.createElement(_FormattedMessage.default, {
  message: "customerDataRte.actions.cancel"
});

var defaultProps = {
  cancelLabel: GENERIC_CANCEL_LABEL,
  className: 'm-top-0',
  controlSize: 'extra-small',
  insetUseClassName: 'p-x-5',
  open: false,
  saveDisabled: false,
  saveLabel: GENERIC_SAVE_LABEL,
  saveOnEnter: true,
  saveTooltip: {
    open: false
  },
  showControlsBorder: false,
  use: 'inset',
  showCancel: true
};

var RichTextEditorSlideoutDrawer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RichTextEditorSlideoutDrawer, _PureComponent);

  function RichTextEditorSlideoutDrawer() {
    var _this;

    (0, _classCallCheck2.default)(this, RichTextEditorSlideoutDrawer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditorSlideoutDrawer).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(RichTextEditorSlideoutDrawer, [{
    key: "getConditionalClasses",
    value: function getConditionalClasses() {
      return (0, _defineProperty2.default)({}, this.props.insetUseClassName, this.props.use === 'inset');
    }
  }, {
    key: "renderControlsAreaComponent",
    value: function renderControlsAreaComponent() {
      var _this$props = this.props,
          ControlsAreaComponent = _this$props.ControlsAreaComponent,
          controlsAreaComponentProps = _this$props.controlsAreaComponentProps;

      if (!ControlsAreaComponent) {
        return null;
      }

      return _react.default.createElement(ControlsAreaComponent, controlsAreaComponentProps);
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this$props2 = this.props,
          controlsClassName = _this$props2.controlsClassName,
          controlSize = _this$props2.controlSize,
          saveLabel = _this$props2.saveLabel,
          saveDisabled = _this$props2.saveDisabled,
          onSave = _this$props2.onSave,
          cancelLabel = _this$props2.cancelLabel,
          onCancel = _this$props2.onCancel,
          saveTooltip = _this$props2.saveTooltip,
          secondarySaveButtonContent = _this$props2.secondarySaveButtonContent,
          onSecondarySave = _this$props2.onSecondarySave,
          showCancel = _this$props2.showCancel;
      var classes = (0, _classnames.default)('rich-text-editor-controls', controlsClassName);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_UITooltip.default, saveTooltip, _react.default.createElement(_UIButton.default, {
        disabled: saveDisabled,
        onClick: onSave,
        size: controlSize,
        use: "primary",
        "data-selenium-test": "rich-text-editor-controls__save-btn"
      }, saveLabel)), secondarySaveButtonContent && secondarySaveButtonContent(onSecondarySave), showCancel && _react.default.createElement(_UIButton.default, {
        onClick: onCancel,
        size: controlSize,
        use: "secondary"
      }, cancelLabel));
    }
  }, {
    key: "renderRedesignedButtons",
    value: function renderRedesignedButtons() {
      var _this$props3 = this.props,
          saveDisabled = _this$props3.saveDisabled,
          onSave = _this$props3.onSave,
          onCancel = _this$props3.onCancel,
          saveTooltip = _this$props3.saveTooltip,
          secondarySaveButtonContent = _this$props3.secondarySaveButtonContent,
          onSecondarySave = _this$props3.onSecondarySave,
          controlsClassName = _this$props3.controlsClassName;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(controlsClassName)
      }, _react.default.createElement(_UITooltip.default, saveTooltip, _react.default.createElement(_UIButton.default, {
        disabled: saveDisabled,
        onClick: onSave,
        use: "tertiary",
        size: "xs",
        "data-selenium-test": "rich-text-editor-controls__save-btn"
      }, GENERIC_SAVE_LABEL)), secondarySaveButtonContent && secondarySaveButtonContent(onSecondarySave), _react.default.createElement(_UIButton.default, {
        onClick: onCancel,
        use: "tertiary-light",
        size: "xs"
      }, GENERIC_CANCEL_LABEL));
    }
  }, {
    key: "renderRedesignedControls",
    value: function renderRedesignedControls() {
      return _react.default.createElement(_UIColumnWrapper.default, null, _react.default.createElement(_UIColumn.default, null, this.renderRedesignedButtons()), this.renderControlsAreaComponent());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          open = _this$props4.open,
          controlsButtonsClassName = _this$props4.controlsButtonsClassName,
          useTertiaryButtons = _this$props4.useTertiaryButtons,
          overrideDrawStyle = _this$props4.overrideDrawStyle;
      var conditionalClassNames = this.getConditionalClasses();
      var useDrawStyle = !useTertiaryButtons && !overrideDrawStyle;
      var wrapperClassNames = (0, _classnames.default)('width-100', conditionalClassNames, controlsButtonsClassName, {
        'draw-controls-container': useDrawStyle
      });

      if (useTertiaryButtons) {
        return this.renderRedesignedControls();
      }

      return _react.default.createElement(_UISlideoutDrawer.default, {
        open: open,
        className: (0, _classnames.default)('communicator-slide-out', {
          'floating-communicator-sticky-footer': this.props.useStickyControls
        })
      }, _react.default.createElement(_UIColumnWrapper.default, {
        key: "emailDrawerButtonsContainer",
        align: "center",
        className: wrapperClassNames
      }, _react.default.createElement(_UIColumn.default, null, this.renderControls()), this.renderControlsAreaComponent()));
    }
  }]);
  return RichTextEditorSlideoutDrawer;
}(_PureComponent2.default);

RichTextEditorSlideoutDrawer.propTypes = propTypes;
RichTextEditorSlideoutDrawer.defaultProps = defaultProps;
var _default = RichTextEditorSlideoutDrawer;
exports.default = _default;
module.exports = exports.default;